import { ReactNode } from 'react';
import { Colors, Icon } from '@mercator-gcp/grout';
import Tooltip from 'components/elements/Tooltip';
import { FlexRow } from 'components/layout/FlexRow';

const basicSpaceStyle = {
  columnGap: 'padding_4',
  justifyContent: 'flex-start',
};

const inlineStyle = {
  display: 'inline-block',
};

type TProps = {
  labelOverride?: string;
  showLabel?: boolean;
  children?: ReactNode;
  inline?: boolean;
  fill?: string;
};

/* This element is used to denote when a value has been predicted by AI. */
const AIMarker = ({
  labelOverride,
  showLabel = true,
  inline = false,
  children,
  fill = Colors.TextQuiet,
}: TProps) => {
  if (!showLabel) {
    return <Icon name={Icon.Name.Sparkles} />;
  }

  if (children) {
    return (
      <FlexRow sx={basicSpaceStyle}>
        {children}
        <Tooltip tooltipText={labelOverride || 'This has been predicted with AI'}>
          <Icon fill={fill} name={Icon.Name.Sparkles} />
        </Tooltip>
      </FlexRow>
    );
  }

  return (
    <Tooltip
      tooltipText={labelOverride || 'This has been predicted with AI'}
      sx={inline ? inlineStyle : undefined}
    >
      <Icon fill={fill} name={Icon.Name.Sparkles} />
    </Tooltip>
  );
};

export default AIMarker;
